/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import Popover from '@material-ui/core/Popover';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import InputBase from '@material-ui/core/InputBase';
import Paper from '@material-ui/core/Paper';
import SaveIcon from '@material-ui/icons/Save';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
}));

const PoperComponent = ({
  handleUpdate,
  handleClose,
  className,
  inputValue,
  anchorEl,
  title,
  open,
  id,
}) => {

  const cardClasses = classNames({
    [className]: className !== undefined
  });
  const classes = useStyles();

  return (
    <>
      <Popover
        className={cardClasses}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Paper component='form' onSubmit={handleUpdate} className={classes.root}>
          <InputBase
            id={id}
            className={classes.input}
            placeholder={title}
            inputProps={{ 'aria-label': `${title}` }}
            {...inputValue}
          />
          <IconButton type='submit' className={classes.iconButton} aria-label='search'>
            <SaveIcon />
          </IconButton>
        </Paper>
      </Popover>
    </>
  )
}

export default PoperComponent
